





































import {Component, Vue, Prop} from "vue-property-decorator";
import DeliveryResponse from "./DeliveryResponse.vue";
import VueError from '@/components/VueError.vue';
import { Delivery } from '@/types/core-push';
import TimestampAgo from "@/components/TimestampAgo.vue";

@Component({
  components:{
    DeliveryResponse,
    VueError,
    TimestampAgo
  }
})

export default class DeliveryRow extends Vue {

  @Prop({ default: {}, type: Object}) delivery!:Delivery;
  @Prop({ default: 0,  type: Number}) index!: number;
  @Prop({ default: '', type: String}) error: string|undefined;



}

